// react
import { lazy } from 'react';

import AuthLayout from 'layout/AuthLayout';
import Loadable from 'components/Loadable';

const MyPage = Loadable(lazy(() => import('pages/MyPage')));
// const MyPageError = Loadable(lazy(() => import('pages/MyPage/Error')));
const Customer = Loadable(lazy(() => import('pages/MyPage/Customer')));
const CustomerEdit = Loadable(lazy(() => import('pages/MyPage/Customer/Edit')));
const CustomerForm = Loadable(lazy(() => import('sections/customer/Form')));
const CustomerConfirm = Loadable(lazy(() => import('sections/customer/Confirm')));
const CustomerComplete = Loadable(lazy(() => import('sections/customer/Complete')));
const Credit = Loadable(lazy(() => import('pages/MyPage/Credit')));
const CreditDelete = Loadable(lazy(() => import('sections/credit/Delete')));
const CreditDeleteComplete = Loadable(lazy(() => import('sections/credit/DeleteComplete')));
const BankAccount = Loadable(lazy(() => import('pages/MyPage/BankAccount')));
const BankAccountForm = Loadable(lazy(() => import('sections/bankAccount/Form')));
const BankAccountComplete = Loadable(lazy(() => import('sections/bankAccount/Complete')));
const Certificate = Loadable(lazy(() => import('pages/MyPage/Certificate')));
const CertificateForm = Loadable(lazy(() => import('sections/certificate/Form')));
const CertificateComplete = Loadable(lazy(() => import('sections/certificate/Complete')));
const Password = Loadable(lazy(() => import('pages/MyPage/Password')));
const PasswordForm = Loadable(lazy(() => import('sections/password/Form')));
const PasswordComplete = Loadable(lazy(() => import('sections/password/Complete')));
const Purchase = Loadable(lazy(() => import('pages/MyPage/Purchase')));
const Receipt = Loadable(lazy(() => import('pages/MyPage/Purchase/Receipt')));
const Extend = Loadable(lazy(() => import('pages/MyPage/Extend')));
const ExtendForm = Loadable(lazy(() => import('sections/extend/Form')));
const ExtendConfirm = Loadable(lazy(() => import('sections/extend/Confirm')));
const ExtendComplete = Loadable(lazy(() => import('sections/extend/Complete')));
const Logout = Loadable(lazy(() => import('pages/Logout')));

const AuthRoutes = {
  path: 'rental',
  element: <AuthLayout variant="rental" />,
  children: [
    {
      path: 'mypage',
      children: [
        {
          path: '',
          element: <MyPage />
        },
        {
          path: 'customer',
          children: [
            {
              path: '',
              element: <Customer />
            },
            {
              path: 'edit',
              element: <CustomerEdit />,
              children: [
                {
                  path: '',
                  element: <CustomerForm />
                },
                {
                  path: 'confirm',
                  element: <CustomerConfirm />
                },
                {
                  path: 'complete',
                  element: <CustomerComplete />
                }
              ]
            }
          ]
        },
        {
          path: 'credit',
          element: <Credit />,
          children: [
            {
              path: '',
              element: <CreditDelete />
            },
            {
              path: 'complete',
              element: <CreditDeleteComplete />
            }
          ]
        },
        {
          path: 'bank',
          element: <BankAccount />,
          children: [
            {
              path: '',
              element: <BankAccountForm />
            },
            {
              path: 'complete',
              element: <BankAccountComplete />
            }
          ]
        },
        {
          path: 'certificate',
          element: <Certificate />,
          children: [
            {
              path: '',
              element: <CertificateForm />
            },
            {
              path: 'complete',
              element: <CertificateComplete />
            }
          ]
        },
        {
          path: 'password',
          element: <Password />,
          children: [
            {
              path: '',
              element: <PasswordForm />
            },
            {
              path: 'complete',
              element: <PasswordComplete />
            }
          ]
        },
        {
          path: 'purchase',
          element: <Purchase />
        },
        {
          path: 'purchase/:orderId',
          element: <Receipt />
        },
        {
          path: 'extend',
          element: <Extend />,
          children: [
            {
              path: '',
              element: <ExtendForm />
            },
            {
              path: 'confirm',
              element: <ExtendConfirm />
            },
            {
              path: 'complete',
              element: <ExtendComplete />
            }
          ]
        }
      ]
    },
    {
      path: 'logout',
      element: <Logout />
    }
  ]
};

export default AuthRoutes;
